export const DELIVERABLE_TYPES = [
  "Post",
  "Reel",
  "Story",
  "Video",
  "Blog Post",
  "Review",
  "Unboxing",
  "Tutorial",
  "Other",
];

export const DELIVERABLE_PLATFORMS = [
  "Instagram",
  "YouTube",
];

export const DELIVERABLE_STATUSES = [
  "In Progress",
  "Pending Approval",
  "Approved",
  "Revision Needed",
  "Delivered",
];
